import { render, staticRenderFns } from "./leftBanner.vue?vue&type=template&id=e5248f10&scoped=true"
import script from "./leftBanner.vue?vue&type=script&lang=js"
export * from "./leftBanner.vue?vue&type=script&lang=js"
import style0 from "./leftBanner.vue?vue&type=style&index=0&id=e5248f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5248f10",
  null
  
)

export default component.exports